module.exports = __webpack_public_path__ + "img/春节大促_41.f5c4be2a.png";